import { apiSlice } from "../../apiSlice";

const headers = { Modulecima: "dashboax" };

export const opepanelApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getOpePanelData: builder.query({
      query: (params = {}) => ({
        url: `/Dashboax/Graphics/OpePanel`,
        method: "GET",
        headers,
        params,
      }),
    }),
    getOpePanelDoData: builder.mutation({
      query: (body) => ({
        url: `/Dashboax/Graphics/OpePanel/doData`,
        method: "POST",
        headers,
        body,
      }),
    }),
    getDoGraphicById: builder.mutation({
      query: (parameters) => ({
        url: `/Dashboax/Graphics/OpePanel/getDoById`,
        method: "GET",
        headers,
        params: parameters,
      }),
    }),
  }),
});

export const {
  useGetOpePanelDataQuery,
  useGetOpePanelDoDataMutation,
  useGetDoGraphicByIdMutation,
} = opepanelApiSlice;

